import axiosInstance from './axiosInstance';
import {
  IPptPolicyAdminResponse,
  IPptPolicyContent,
  IPptPolicyPluginResponse,
  IPptPolicyUploadResult,
  IPptPolicyViewResponse,
} from '../types/pptPolicies';

export const pptPoliciesService = {
  async fetchPage() {
    const { data } = await axiosInstance.get<IPptPolicyViewResponse>('/api/ppt-policies');
    return data;
  },

  async fetchPluginView() {
    const { data } = await axiosInstance.get<IPptPolicyPluginResponse>('/api/ppt-policies/plugin');
    return data;
  },

  async fetchAdminPage() {
    const { data } = await axiosInstance.get<IPptPolicyAdminResponse>('/api/ppt-policies/admin');
    return data;
  },

  async updateDraft(payload: IPptPolicyContent) {
    const { data } = await axiosInstance.put<IPptPolicyAdminResponse>('/api/ppt-policies/admin', payload);
    return data;
  },

  async publishDraft() {
    const { data } = await axiosInstance.post('/api/ppt-policies/admin/publish');
    return data;
  },

  async uploadImage(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    const { data } = await axiosInstance.post<IPptPolicyUploadResult>(
      '/api/ppt-policies/admin/uploads/image',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return data;
  },

  async uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await axiosInstance.post<IPptPolicyUploadResult>(
      '/api/ppt-policies/admin/uploads/file',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return data;
  },
};

export default pptPoliciesService;
